<template>
  <div>
    <v-container>
      <h3>{{targetType}} Video Scripts</h3>
      <hr />
      <v-expansion-panels v-model="expandedPanels" multiple>
        <v-expansion-panel v-for="(script, index) in scripts" :key="index">
          <v-expansion-panel-title>
            <h4>{{ script.title }}</h4>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <v-card outlined>
              <v-card-text>
                <!-- Script Section -->
                <div>
                  <div class="script-header">
                    <h3>Script:</h3>
                    <v-btn fab icon small @click="copyText(caption.caption, CopyType.SCRIPT)" class="fab-btn">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </div>
                  <p class="script-text">
                    {{ script.script }}
                  </p>
                </div>
                <v-divider class="my-3"></v-divider>
  
                <!-- Caption Section -->
                <div>
                  <div class="caption-header">
                    <h3>Caption:</h3>
                    <v-btn fab icon small @click="copyText(caption.caption, CopyType.CAPTION)" class="fab-btn">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </div>
                  <p class="script-text">{{ script.caption }}</p>
                </div>
                <v-divider class="my-3"></v-divider>
                <!-- Hashtags Section -->
                <div>
                  <div class="caption-header">
                    <h3>Hashtags:</h3>
                    <v-btn fab icon small @click="copyText(caption.caption, CopyType.HASHTAG)" class="fab-btn">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </div>
                  <v-textarea
                    readonly
                    :value="formatHashtags(script.hashtags)"
                    outlined
                    rows="2"
                    class="mb-3"
                  ></v-textarea>
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <v-snackbar v-model="snackbar" :timeout="2000" color="success">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>
  
<script>
  const CopyType = Object.freeze({
    SCRIPT: 'Script',
    CAPTION: 'Caption',
    HASHTAG: 'Hashtag'
  });
  export default {
    data() {
      return {
        CopyType,
        scripts: [],
        expandedPanels: [0],
        previousMonth: '',
        currentMonth: '',
        targetType: '',
        region: '',
        snackbar: false,
        snackbarText: '',
      };
    },
    mounted() {
      this.targetType = this.$route.query.targetType || '';
      this.previousMonth = this.$route.query.previousMonth || '';
      this.currentMonth = this.$route.query.currentMonth || '';
      this.loadScriptsBasedOnQuery();
    },
    methods: {
      // Format hashtags as a single string
      formatHashtags(hashtags) {
        return hashtags.join(' ');
      },
      copyText(text, type) {
        navigator.clipboard.writeText(text).then(() => {
          // Show a toast/snackbar or notification when the text is copied
          this.snackbarText = `${type} Script copied to clipboard!`;
          this.snackbar = true;
        }).catch(err => {
          console.error('Failed to copy: ', err);
          this.snackbarText = 'Failed to copy text';
          this.snackbar = true;
        });
      },
      async loadScriptsBasedOnQuery() {
        const region = this.$route.query.region; // Check for 'region' in the query string
        if (region === 'USA') {
          if(this.targetType === this.previousMonth) {
            const videoScripts = await import('@/assets/video-scripts-previous-usa.json');
            this.scripts = videoScripts.default; // dynamically load the USA scripts
          } else {
            const videoScripts = await import('@/assets/video-scripts-current-usa.json');
            this.scripts = videoScripts.default; // dynamically load the USA scripts
          }
        } else if (region === 'Canada') {
          if(this.targetType === this.previousMonth) {
            const videoScripts = await import('@/assets/video-scripts-previous-canada.json');
            this.scripts = videoScripts.default; // dynamically load the Canada scripts
          } else {
            const videoScripts = await import('@/assets/video-scripts-current-canada.json');
            this.scripts = videoScripts.default; // dynamically load the Canada scripts
          }
        } else {
          // Default or fallback, if needed
          const videoScripts = [];
          this.scripts = videoScripts; 
        }
      },
    },
  };
</script>
  
<style scoped>
  .script-header {
    display: flex; /* Aligns the h3 and the button in a row */
    align-items: center; /* Vertically centers the items */
    justify-content: space-between;
    padding: 8px, 0;
  }
  .script-text {
    white-space: pre-wrap;
    position: relative;
    padding: 16px
  }

  .fab-btn {
    /* position: absolute; */
    top: 0;
    right: 0;
    margin-right: 8px;
    z-index: 1;
  }

  .v-card-text {
    padding: 16px;
  }
  
  .v-expansion-panel-header {
    font-weight: bold;
    font-size: 1.2rem;
  }
  
  .v-expansion-panel {
    margin-bottom: 10px;
  }
  
  .v-textarea {
    background-color: #f5f5f5;
    border-radius: 4px;
    font-family: monospace;
  }
  
  .v-expansion-panels {
    margin-top: 20px;
  }
  
  h3 {
    margin-bottom: 8px;
  }
</style>
  